// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3e5Lq","col":"styles_col__3NGLG"};